import { render, staticRenderFns } from "./19_ap_secciones_aduaneras.vue?vue&type=template&id=b134b958&scoped=true&"
import script from "./19_ap_secciones_aduaneras.vue?vue&type=script&lang=js&"
export * from "./19_ap_secciones_aduaneras.vue?vue&type=script&lang=js&"
import style0 from "./19_ap_secciones_aduaneras.vue?vue&type=style&index=0&id=b134b958&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b134b958",
  null
  
)

export default component.exports